<template>
  <footer class="footer">
    <p class="m-0">SCL {{info}} · Associação dos Criadores de Gado Jersey do Brasil</p>
  </footer>
</template>

<script>
import {version} from "../../../package.json";
export default {
  name:"TheFooter",
  data() {
    return {
      info:""
    }
  },
  mounted() {
    this.info = version;
  }
}
</script>

<style scoped>
  .footer {
    width: 100%;
    padding: 10px 0 22px;
    display: flex;
    justify-content: center;
  }

  .footer p {
    color: var(--muted);
    font-size: .78rem;
  }
</style>
